/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: '検索',
  search_no_results_1: '問題が発生しました。',
  search_no_results_2: 'その絵文字は見つかりませんでした。',
  pick: '絵文字を選択…',
  add_custom: 'カスタムの絵文字を追加',
  categories_activity: 'アクティビティ',
  categories_custom: 'カスタム',
  categories_flags: '旗',
  categories_foods: '食べ物・飲み物',
  categories_frequent: 'よく使う',
  categories_nature: '動物・自然',
  categories_objects: 'もの',
  categories_people: '表情・人',
  categories_places: '旅行・場所',
  categories_search: '検索結果',
  categories_symbols: '記号',
  skins_choose: 'デフォルトのスキントーンを選択',
  skins_1: '既定',
  skins_2: '明るい',
  skins_3: 'やや明るい',
  skins_4: '普通',
  skins_5: 'やや濃い',
  skins_6: '濃い',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
